import request from 'umi-request';

export async function getUser(data: any) {
  return await request('/local/auth/login_with_username_password', {
    data: {
      username: data.username,
      password: data.password
    },
    method: 'POST',
  });
}

export async function changePassword(data: { username: string; oldPassword: string; newPassword: string }) {
  return await request('/local/auth/change_password', {
    data,
    method: 'POST',
  });
}

export async function getCredentials() {
  return (await request('/local/auth/get_qr_code_init_info')).data;
}
